import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import { Circle } from '../../TheMoshiDifference/TheMoshiDifference'
class index extends Component {
	render() {
		return (
			<div className="page-case-study">
				<Header
					bg="#230205"
					title={"Bushfire Front"}
					image={require('./video.jpg')}
					video={{ mp4: require('./video.mp4'), webm: require('./video.webm')}}
				/>
				<div className="entry-content">
					
					<div className="container-fluid">
						<h2 className="outline text-center">
							<div className="line"></div>
							<div className="title">The need for a strong visual public face</div>
						</h2>
						<div className="row">
							<div className="col-lg-1"></div>
							<div className="col-lg-3">
								<Circle image={require('../../ContactUs/bushfire-front.png')} />
							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-6">
								<div className="tagline">Moshi Moshi provided marketing consultancy, branding, website design and design of business materials.</div>
								<p>Assistance included:</p>
								<ul className="with-icons">
									<li>Marketing Strategy</li>
									<li>Website <a href="https://www.bushfirefront.org.au" target="_blank">www.bushfirefront.org.au</a></li>
									<li>Responsive design to work on all devices</li>
									<li>Video banner to grab attention</li>
									<li>Animated elements to smooth flow</li>
									<li>Business card and letterhead design</li>
								</ul>
							</div>
						</div>
					</div>

					<div className="container-fluid example-work">
						<div className="row">
						<div className="col-lg-1"></div>
						<div className="col-lg-6">
							<img src={require('./feature.jpg')} alt="Bushfire Front Feature" width="100%" />
						</div>
							<div className="col-lg-4">
								<img src={require('./example-1.jpg')} alt="Bushfire Front Feature" width="100%" />
								<img src={require('./example-2.jpg')} alt="Bushfire Front Feature" width="100%" />
								<img src={require('./example-3.jpg')} alt="Bushfire Front Feature" width="100%" />
						</div>
							<div className="col-lg-1"></div>
						</div>
					</div>


					

				</div>


			</div>
		);
	}
}

export default index;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeveDone/BushfireFront/index.js